import { combineReducers, configureStore } from "@reduxjs/toolkit";
import floorPlanReducer from "./slicers/selectedFloorPlan";
import moodBoardUserReducer from "./slicers/moodBoardUser";
import userInfoReducer from "./slicers/authInfo";
const rootReducer = combineReducers({
  floorPlan: floorPlanReducer,
  moodBoardUser: moodBoardUserReducer,
  userInfo: userInfoReducer,
});

const store = configureStore({ reducer: rootReducer });
export default store;
